<script lang="ts" setup>
// Imports ............................................................
import { DsButton, DsDialog } from '@packages/design'
import { useReleaseWatcher } from '@/composables/useReleaseWatcher'

// Composables ........................................................
const { updateAvailable, dismiss, refresh } = useReleaseWatcher()

// State ..............................................................
/** Where to read about the update. The page only has it for site admins and up. */
const whatsNewUrl =
  document.head.querySelector<HTMLMetaElement>('meta[name="whats-new-url"]')?.content || null
</script>

<template>
  <ds-dialog
    class="release-update-dialog"
    label="A new version is available"
    :open="updateAvailable || undefined"
    @wa-after-hide="
      (event: Event) => event.target === event.currentTarget && updateAvailable && dismiss()
    "
  >
    <p class="release-update-dialog__text">
      The site has been updated since you opened this page. Refresh to see the latest changes.
    </p>
    <p v-if="whatsNewUrl" class="release-update-dialog__text">
      <a :href="whatsNewUrl">See what's new</a>
    </p>
    <p class="release-update-dialog__text release-update-dialog__text--quiet">
      If you have unsaved work, choose <strong>Not now</strong> and save it first.
    </p>
    <div slot="footer" class="release-update-dialog__footer">
      <ds-button appearance="outlined" @click="dismiss()">Not now</ds-button>
      <ds-button variant="brand" @click="refresh()">Refresh</ds-button>
    </div>
  </ds-dialog>
</template>

<style scoped>
.release-update-dialog {
  --width: min(28rem, 92vw);
}

.release-update-dialog__text {
  margin: 0 0 var(--wa-space-s);
}

.release-update-dialog__text--quiet {
  margin-block-end: 0;
  color: var(--wa-color-text-quiet);
  font-size: var(--wa-font-size-s);
}

.release-update-dialog__footer {
  display: flex;
  justify-content: flex-end;
  gap: var(--wa-space-s);
}
</style>
